import { useState } from 'react';
import { SketchPicker } from 'react-color';

export const availableFonts = [
  { name: 'Weirdo', fontFamily: '"Weirdo", cursive' },
  { name: 'Impact', fontFamily: 'Impact, Haettenschweiler, "Arial Narrow Bold", sans-serif' },
  { name: 'Arial', fontFamily: 'Arial, sans-serif' },
  { name: 'Times', fontFamily: '"Times New Roman", Times, serif' },
  { name: 'Courier', fontFamily: '"Courier New", Courier, monospace' }
];

export const AddTextSelector = ({ addTextLayer }) => {
  const [selectedFont, setSelectedFont] = useState('Weirdo');
  const [text, setText] = useState('');
  const [textColor, setTextColor] = useState('#000000');
  const [outlineColor, setOutlineColor] = useState('#ffffff');
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [showOutlineColorPicker, setShowOutlineColorPicker] = useState(false);
  

  const handleColorChange = (color) => {
    setTextColor(color.hex);
  };

  const handleOutlineColorChange = (color) => {
    setOutlineColor(color.hex);
  };

  return (
    <div className="w-full h-full flex flex-col items-start justify-start md:p-2 font-bold font-sans gap-2 md:gap-4">
      <div className="w-full flex flex-col justify-evenly items-start">
        <p className="px-1 text-gray-700 text-xs md:text-sm font-semibold whitespace-nowrap">Text:</p>
        <input type="text" className="w-full p-2 bg-[#eaebed] rounded-sm text-xs font-normal outline-none focus:outline-none focus:ring-0" value={text} onChange={(e) => setText(e.target.value)} />
      </div>
      
      <div className="w-full flex flex-row md:flex-col justify-evenly items-center md:items-start gap-2">
        <div className="w-full flex flex-col items-start">
          <p className="px-1 text-gray-700 text-xs md:text-sm font-semibold">Font:</p>
          <select 
            className="w-full p-1 md:p-2 bg-[#eaebed] rounded-sm text-xs font-normal outline-none focus:outline-none focus:ring-0"
            value={selectedFont}
            onChange={(e) => setSelectedFont(e.target.value)}
          >
            {availableFonts.map((font) => (
              <option key={font.name} value={font.name} className="text-gray-700 text-xs">
                {font.name}
              </option>
            ))}
          </select>
        </div>

        <div className="w-full flex flex-col items-start">
          <p className="px-1 text-gray-700 text-xs md:text-sm font-semibold">Text Color:</p>
          <div className="relative w-full">
            <div 
              className="w-full h-8 bg-[#eaebed] rounded-sm border cursor-pointer flex items-center px-2"
              onClick={() => setShowColorPicker(!showColorPicker)}
            >
              <div 
                className="w-6 h-6 rounded border border-gray-300 mr-2"
                style={{ backgroundColor: textColor }}
              ></div>
              <span className="text-xs text-gray-700">{textColor}</span>
            </div>
            {showColorPicker && (
              <div className="fixed inset-0 z-20 flex items-center justify-center">
                <div 
                  className="absolute inset-0" 
                  onClick={() => setShowColorPicker(false)}
                ></div>
                <SketchPicker
                  color={textColor}
                  onChange={handleColorChange}
                  disableAlpha={true}
                />
              </div>
            )}
          </div>
        </div>

        {selectedFont !== 'Weirdo' && (
          <div className="w-full flex flex-col items-start">
            <p className="px-1 text-gray-700 text-xs md:text-sm font-semibold">Outline Color:</p>
            <div className="relative w-full">
              <div 
                className="w-full h-8 bg-[#eaebed] rounded-sm border cursor-pointer flex items-center px-2"
                onClick={() => setShowOutlineColorPicker(!showOutlineColorPicker)}
              >
                <div 
                  className="w-6 h-6 rounded border border-gray-300 mr-2"
                  style={{ backgroundColor: outlineColor }}
                ></div>
                <span className="text-xs text-gray-700">{outlineColor}</span>
              </div>
              {showOutlineColorPicker && (
                <div className="fixed inset-0 z-20 flex items-center justify-center">
                  <div 
                    className="absolute inset-0" 
                    onClick={() => setShowOutlineColorPicker(false)}
                  ></div>
                  <SketchPicker
                    color={outlineColor}
                    onChange={handleOutlineColorChange}
                    disableAlpha={true}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      <div className="w-full flex flex-col items-start border-2 border-slate-400/20 rounded-sm p-2 bg-[#eaebed]">
        <p 
          className="text-gray-700 font-normal text-xl font-bold text-center w-full" 
          style={{ 
            fontFamily: selectedFont, 
            color: textColor,
            ...(selectedFont !== 'Weirdo' && {
              textShadow: `
                -1px -1px 0 ${outlineColor},
                1px -1px 0 ${outlineColor},
                -1px 1px 0 ${outlineColor},
                1px 1px 0 ${outlineColor},
                -2px 0 0 ${outlineColor},
                2px 0 0 ${outlineColor},
                0 -2px 0 ${outlineColor},
                0 2px 0 ${outlineColor}
              `
            })
          }}
        >
          Font preview
        </p>
      </div>
      
      <button 
        className={`
          w-full 
          bg-[#f2a902] text-white py-1 rounded-md ${text.length === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:brightness-110 active:brightness-150 transition-all duration-300 cursor-pointer'}`
        }
        disabled={text.length === 0}
        onClick={() => {
          addTextLayer(text, selectedFont, textColor, selectedFont === 'Weirdo' ? null : outlineColor);
          setText('');
        }}
      >
        Add text
      </button>
    </div>
  );
};